<template lang="pug">
.cadastro-requisito-item
  .cadastro-requisito-item__icon
    img(src="@/assets/icons/cadastro/file-text.svg" alt="")
  .cadastro-requisito-item__content
    .cadastro-requisito-item__header
      span.cadastro-requisito-item__titulo {{ titulo }}
      span.cadastro-requisito-item__badge(v-if="obrigatorio") Obrigatório
    p.cadastro-requisito-item__descricao(v-if="descricao") {{ descricao }}
</template>

<script>
export default {
  name: 'CadastroRequisitoItem',
  props: {
    titulo: {
      type: String,
      required: true
    },
    obrigatorio: {
      type: Boolean,
      default: false
    },
    descricao: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-requisito-item {
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
}

.cadastro-requisito-item__icon {
  align-items: center;
  background: rgba(24, 197, 194, 0.1);
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  width: 36px;

  img {
    height: 16px;
    width: 16px;
  }
}

.cadastro-requisito-item__content {
  flex: 1;
  min-width: 0;
}

.cadastro-requisito-item__header {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cadastro-requisito-item__titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
}

.cadastro-requisito-item__badge {
  border: 1px solid #eaeaea;
  border-radius: 26px;
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.43;
  padding: 2px 6px;
}

.cadastro-requisito-item__descricao {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.625;
  margin: 4px 0 0;
}
</style>
